module.exports = "﻿﻿<div class=\"wrapper wrapper-content animated fadeInRight\">\r\n    <div class=\"row\">\r\n        <div class=\"col-lg-8 col-lg-offset-2\">\r\n            <div class=\"ibox float-e-margins\" *ngIf=\"pageContent\">\r\n                <div class=\"ibox-content\">\r\n                    <b>Email account registered: {{email}}</b>\r\n                </div>\r\n                <div class=\"ibox-content\" [innerHtml]=\"pageContent | safeHtml\">                    \r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/registration/thank.you.component.html
// module id = 1215
// module chunks = 0